import { Injectable } from '@angular/core';
import { Resource } from './resource';

@Injectable()
export class ResourceService {
    public getResource(key): string {
        return Resource[key];
    }
    public getDefaultAvatar(gender = '') {
        switch (gender) {
            case 'male': {
                return Resource.maleDefaultAvatar;
            }
            case 'female': {
                return Resource.femaleDefaultAvatar;
            }
            default: {
                return Resource.defaultAvatar;
            }
        }
    }

    public getDefaultBackground() {
    }

    public getBadge(role, size = 's') {
        switch (role) {
            case 'cpvip': {
                if (size === 's') {
                    return Resource.mCpVipBadge;
                }
                return Resource.cpVipBadge;
            }
            case 'editor': {
                if (size === 's') {
                    return Resource.mEditorBadge;
                }
                return Resource.editorBadge;
            }
            case 'etvip': {
                if (size === 's') {
                    return Resource.mEtVipBadge;
                }
                return Resource.etVipBadge;
            }
            case 'gvip': {
                if (size === 's') {
                    return Resource.mGVipBadge;
                }
                return Resource.gVipBadge;
            }
            case 'vip': {
                // if (size === 's') {
                //     return Resource.mVipBadge;
                // }
                // return Resource.vipBadge;
                return '';
            }
            case 'royalAdmin': {
                if (size === 's') {
                    return Resource.mRoyalAdminBadge;
                }
                return Resource.royalAdminBadge;
            }
            case 'royalVip': {
                if (size === 's') {
                    return Resource.mRoyalVipBadge;
                }
                return Resource.royalVipBadge;
            }
            case 'bigV': {
                if (size === 's') {
                    return Resource.mBigVBadge;
                }
                return Resource.bigVBadge;
            }
            default: {
                return '';
            }
        }
    }
}
